module.exports = function () {/* empty */};